import type { ComponentStyleConfig } from '@chakra-ui/theme'

const Button: ComponentStyleConfig = {
  defaultProps: {
    size: 'md',
    variant: 'solid',
  },
}

export default Button
